var map = {
	"./ID.webp": 780,
	"./INDO.webp": 781,
	"./MY.webp": 782,
	"./TH.webp": 783,
	"./VN.webp": 784,
	"./malaysia.webp": 785
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 397;
module.exports = webpackAsyncContext;